import { render, staticRenderFns } from "./appSidebar.vue?vue&type=template&id=4815c44a&scoped=true&"
import script from "./appSidebar.vue?vue&type=script&lang=js&"
export * from "./appSidebar.vue?vue&type=script&lang=js&"
import style0 from "./appSidebar.vue?vue&type=style&index=0&id=4815c44a&scoped=true&lang=css&"
import style1 from "./appSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4815c44a",
  null
  
)

export default component.exports